var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-md"},[_vm._v(" Leilão imperdível dia 03/11 "),_c('campanha-icone')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }